import { WalletIcon } from 'lucide-react'

import { Text } from '@/components/ui/text'
import { JobSalaryPeriod } from '@/shared/domain/enums/job/job-salary-period.enum'
import { JobBoardExpectedSalary } from '@/types/application/job-board'
import { formatSalary } from '@/utils/string'

const periodMapping: Record<JobSalaryPeriod, string> = {
  [JobSalaryPeriod.DAY]: 'd',
  [JobSalaryPeriod.HOUR]: 'h',
  [JobSalaryPeriod.MONTH]: 'm',
  [JobSalaryPeriod.YEAR]: 'y',
}

export default function ExpectedSalary({ expectedSalary }: { expectedSalary: JobBoardExpectedSalary | null }) {
  return (
    <div className="flex items-center gap-x-1">
      <WalletIcon className="size-4 shrink-0 text-muted-foreground" />
      {expectedSalary && (
        <Text breakAll size="xs">
          {`${formatSalary(expectedSalary.averageSalary, expectedSalary.currency)}/${periodMapping[expectedSalary.period]}`}
        </Text>
      )}
    </div>
  )
}
